import * as React from 'react';

const ElectronicsBadgeMultichrome64 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 64 64", width: 64, height: 64, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1EAE1",
    d: "M64 32c0 17.672-14.327 32-32 32C14.328 64 0 49.672 0 32 0 14.327 14.328 0 32 0c17.673 0 32 14.327 32 32Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M38.723 17.27a2.998 2.998 0 0 1-2.12-.877l-2.51-2.51a2.998 2.998 0 0 0-4.24 0l-2.509 2.51a2.998 2.998 0 0 1-2.12.878h-4.562a3 3 0 0 0-2.998 3v4.558c0 .796-.317 1.56-.88 2.123l-2.931 2.93a3.002 3.002 0 0 0 0 4.246l2.931 2.931c.563.563.88 1.327.88 2.123v3.722a3 3 0 0 0 2.998 3h3.728a3 3 0 0 1 2.12.88l3.344 3.343a2.998 2.998 0 0 0 4.24 0l3.344-3.344a2.998 2.998 0 0 1 2.12-.878h3.727a3 3 0 0 0 3-3v-3.723a3 3 0 0 1 .878-2.123l2.931-2.93a3.002 3.002 0 0 0 0-4.246l-2.93-2.931a3.002 3.002 0 0 1-.88-2.123v-4.557a3 3 0 0 0-2.999-3.001h-4.562Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "M25.946 24.378a9.5 9.5 0 1 0 12.108 0l-1.9 2.322a6.5 6.5 0 1 1-8.309 0l-1.9-2.322Z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M33.5 22.2v9h-3v-9h3Z" }));
ElectronicsBadgeMultichrome64.Size = 64;
ElectronicsBadgeMultichrome64.Title = "ElectronicsBadgeMultichrome";

export { ElectronicsBadgeMultichrome64 as default };
